import { CssBaseline, ThemeProvider, createTheme } from "@mui/material";
import { useState } from "react";

import { appConfig } from "../config";
import { Main } from "../views/Main";
import { Signup } from "../views/Signup";

const theme = createTheme({
  palette: {
    background: {
      default: "#e3e3e3",
    },
    primary: {
      main: "#0b3b2e",
    },
    secondary: {
      main: "#c89b3c",
    },
  },
  shape: {
    borderRadius: 8,
  },
});

export function App(): JSX.Element {
  const [showMain, setShowMain] = useState(() => shouldShowMain());

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {showMain ? <Main /> : <Signup onSneakPreview={() => setShowMain(true)} />}
    </ThemeProvider>
  );
}

export function shouldShowMain(now = Date.now()): boolean {
  return now > Date.parse(appConfig.defaultRevealTimestamp);
}
